// 从 localStorage 获取功能权限（用于组件/按钮级别的权限控制）
export const getFunctionPermissions = () => {
  try {
    const permissions = localStorage.getItem('permissions');
    return permissions ? JSON.parse(permissions) : [];
  } catch (error) {
    console.error('获取功能权限失败:', error);
    return [];
  }
};

// 检查单个功能权限
export const hasPermission = (permission) => {
  if (!permission) return true;

  const permissionList = getFunctionPermissions();

  // 支持权限字符串或权限数组
  if (Array.isArray(permission)) {
    return permission.some(p => permissionList.includes(p));
  }

  return permissionList.includes(permission);
};

// 检查多个权限（全部满足）
export const hasPermissions = (permissions) => {
  if (!permissions || permissions.length === 0) return true;

  return permissions.every(permission => hasPermission(permission));
};

// 检查任意权限（满足一个即可）
export const hasAnyPermission = (permissions) => {
  if (!permissions || permissions.length === 0) return true;

  return permissions.some(permission => hasPermission(permission));
};

// 角色检查
export const hasRole = (role) => {
  const roles = JSON.parse(localStorage.getItem('roles') || '[]');
  if (!role) return true;

  if (Array.isArray(role)) {
    return role.some(r => roles.includes(r));
  }

  return roles.includes(role);
};

// 检查多个角色
export const hasRoles = (roles) => {
  if (!roles || roles.length === 0) return true;

  return roles.every(role => hasRole(role));
};

// 检查任意角色
export const hasAnyRole = (roles) => {
  if (!roles || roles.length === 0) return true;

  return roles.some(role => hasRole(role));
};

// 导出常用函数
export default {
  getFunctionPermissions,
  hasPermission,
  hasPermissions,
  hasAnyPermission,
  hasRole,
  hasRoles,
  hasAnyRole
};
